"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M4.802 1l15.486 20.648L18.486 23l-4.223-5.631v4.692h-2.816v-7.66A6.572 6.572 0 016.381 6.86L3 2.352 4.802 1zm8.053.413a6.57 6.57 0 013.942 11.826l-2.816-3.754a1.877 1.877 0 10-2.253-3.004L8.914 2.727a6.54 6.54 0 013.942-1.314z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;